export enum UserFeatureFlag {
    AI_SCHEMA_MAPPING_IMPORTS = 'ai_schema_mapping_imports',
    ADVANCED_FEEDAI_CONFIGURATION = 'advanced_feedai_configuration',
    AFB_CATEGORY_SPECIFIC_FIELDS = 'afb_category_specific_fields',
    AUTOMATED_FEED_BUILD_WORKFLOW = 'automatedfeedbuild_workflow',
    AUTOMATED_FEED_BUILD_WORKFLOW_AIATTRIBUTION = 'automatedfeedbuild_workflow_aiattribution',
    CLASSIFIER_INFO = 'classifier_info',
    DASHBOARDS_NAV = 'dashboards_nav',
    DATA_ENRICHMENT = 'data_enrichment',
    DATA_ENRICHMENT_ANALYTICS = 'data_enrichment_analytics',
    DATA_ENRICHMENT_INTERNAL_CONFIG_UPLOAD = 'data_enrichment_internal_config_upload',
    DATA_PAGE_FIELD_POPOVER = 'data_page_field_popover',
    DUP_EXPORT_WITH_SCHEDULE = 'dup_export_with_schedule',
    ERROR_RESOLUTION_MODE = 'error_resolution_mode',
    ERROR_RESOLUTION_CATEGORIES = 'error_resolution_categories',
    EXPORT_WEBHOOK_FOR_POSTMAN = 'export_webhook_for_postman',
    FEATURE_DATA_AI_CATEGORIZATION = 'data_ai_categorization',
    FEATURE_FEED_AI_PROVIDER = 'feed_ai_provider',
    FEATURE_OPS_AB_TESTING_WORKFLOW = 'ops_ab_testing_workflow',
    FEATURE_OPS_EX_PROMO_WORKFLOW = 'ops_ex_promo_workflow',
    FEATURE_OPS_EX_MICROSOFT_PROMO = 'ops_excellence_microsoft_promo',
    GENAI = 'genai',
    GENAI_ATTRIBUTES = 'genai_attributes',
    GENAI_CATEGORIZATION = 'genai_categorization',
    IMPORT_SHOPIFY_THIRD_PARTY_AUTHENTICATION = 'import_shopify_third_party_authentication',
    LIA_RAAP_READINESS_CHECK = 'lia_raap_readiness_check',
    NEW_TRANSFORMERS_PAGE = 'new_transformers_page',
    RUN_ATTRIBUTION = 'run_attribution',
    RUN_CLASSIFY = 'run_classify',
    SURFACE_FEED_AMP = 'surface_feed_amp',
    API_USAGE = 'api_usage',
    SURFACE_USER = 'bc_ss_user',
    TRANSFORMED_DATA_OVERRIDES = 'transformed_data_overrides',
    ADS_DATA_REVIEW = 'ads_data_review'
}
